import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_budget_register_txn_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  budget_gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  currency: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.NumericDatatypeInterface;
  mst_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mst_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_reference_no: fromDatatype.TextDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  pic1_guid: fromDatatype.GuidDataFieldInterface;
  pic1_code: fromDatatype.VarcharDatatypeInterface;
  pic1_table: fromDatatype.VarcharDatatypeInterface;
  pic1_type: fromDatatype.VarcharDatatypeInterface;
  pic2_guid: fromDatatype.GuidDataFieldInterface;
  pic2_code: fromDatatype.VarcharDatatypeInterface;
  pic2_table: fromDatatype.VarcharDatatypeInterface;
  pic2_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_budget_register_txn_line_RowClass
  implements bl_fi_budget_register_txn_line_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  budget_gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  currency: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.NumericDatatypeInterface;
  mst_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mst_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_reference_no: fromDatatype.TextDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  pic1_guid: fromDatatype.GuidDataFieldInterface;
  pic1_code: fromDatatype.VarcharDatatypeInterface;
  pic1_table: fromDatatype.VarcharDatatypeInterface;
  pic1_type: fromDatatype.VarcharDatatypeInterface;
  pic2_guid: fromDatatype.GuidDataFieldInterface;
  pic2_code: fromDatatype.VarcharDatatypeInterface;
  pic2_table: fromDatatype.VarcharDatatypeInterface;
  pic2_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
